import React, { useRef, useState } from 'react';
import {
  Box,
  Button,
  Grid,
  Typography,
} from '@mui/material';
import {
  SimpleDialog,
  TableComponents,
  InputV2,
  ConfirmDialog,
  ButtonLoading,
  FilterPod,
  Icons
} from 'components';
import { getDynamicObjectAction } from 'utility';
import { useLocation } from 'react-router-dom';
import useCustomHook from './hooks';
import createToast from 'components/Toast/Toast';
import copy from 'copy-to-clipboard';
import { columns, generateData } from './Columns';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import CardsServices from '../../services';
import { useStyles } from './style';
import FilterButton from 'components/FilterPod/FilterButton';
import axios from 'axios';

const ShebasList = (props) => {
  const classes = useStyles();
  const {
    isLoading,
    setIsLoading,
    list,
    setList,
    isSubmitting,
    setIsSubmitting,
    setFilterParams,
    size,
    setSize,
    filters,
    setFilters,
    isNewDialogOpen,
    setIsNewDialogOpen,
    confirmDeleteModal,
    setConfirmDeleteModal,
    itemIdToDelete,
    setItemIdToDelete,
    currentId,
    setCurrentId,
    shebaNumber,
    setShebaNumber,
    shebaName,
    setShebaName,
    page,
    setPage,
    isLoadingDelete, setIsLoadingDelete,
  } = useCustomHook();

  let tableRef = useRef();
  // -- HOOKS --//
  ;
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);
  const currentLoaction = useLocation();

  let actionsList = getDynamicObjectAction([
    'shebaNeWCardPage',
    'shebaImprestNeWCardPage',
    'shebaDeleteCardPage',
    'shebaImprestDeleteCardPage',
    'shebaUpdateCardPage',
    'shebaImprestUpdateCardPage'

  ])
  const getItems = async (query) => {
    try {
      setIsLoading(true);
      let filter = toFilterVOS([...filters]);
      let queries = filterVOStoQueryStr(filter);
      setPage(query?.page);
      let params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        ...queries,
      };
      const data = {
        filterVOS: [],
        parentParams: [],
        orderByElementVOS: [],
      };

      setFilterParams({ data, params });

      const res = await CardsServices.getShebas(params);

      let list = [];

      list = generateData(res?.result, {
        page: query ? query?.pageNumber : page,
        pageSize: query?.pageSize || size,
      });
      setIsLoading(false);
      const da = res?.result;
      setList(da);

      let d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      return d; //passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  const postItem = async () => {
    try {
      if (!shebaNumber) {
        createToast('خطا', 'شماره شبا را وارد کنید.', 'danger');
        return;
      }
      if (!shebaName) {
        createToast('خطا', 'عنوان شبا را وارد کنید.', 'danger');

        return;
      }
      const shebaMock = shebaNumber.toLowerCase().replaceAll('ir', '');
      if (shebaMock.length != 24) {
        createToast('خطا', 'شماره شبا باید ۲۶ کاراکتر باشد (به همراه IR)', 'danger');

        return;
      }
      setIsSubmitting(true);
      const body = {
        sheba: shebaMock,
        name: shebaName,
      };
      const result = await CardsServices.postSheba(body);

      handleCloseNew();
      setIsSubmitting(false);
      setPage(0)
      setSize(10)
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100)
    } catch (error) {
      setIsSubmitting(false);
    }
  };

  const putItem = async () => {
    try {
      if (!shebaNumber || shebaNumber.length == 0) {
        createToast('خطا', 'شماره شبا را وارد کنید.', 'danger');

        return;
      }
      if (!shebaName || shebaName.length == 0) {
        createToast('خطا', 'عنوان شبا را وارد کنید.', 'danger');

        return;
      }

      const shebaMock = shebaNumber.toLowerCase().replaceAll('ir', '');
      if (shebaMock.length != 24) {
        createToast('خطا', 'شماره شبا باید ۲۶ کاراکتر باشد (به همراه IR)', 'danger');

        return;
      }
      setIsSubmitting(true);

      const body = {
        sheba: shebaMock,
        name: shebaName,
      };
      const result = await CardsServices.putSheba(currentId, body);

      createToast('موفق', 'اطلاعات شبا با موفقیت بروزرسانی شد', 'success');

      handleCloseNew();
      setIsSubmitting(false);
      setPage(0)
      setSize(10)
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100)
    } catch (error) {
      setIsSubmitting(false);
    }
  };

  const deleteItem = async () => {
    if (!itemIdToDelete) return;
    try {
      setIsLoadingDelete(true)
      const result = await CardsServices.deleteSheba(itemIdToDelete);
      setItemIdToDelete(null);
      setConfirmDeleteModal(false);

      createToast('موفق', 'شبا با موفقیت حذف شد.', 'success');
      setPage(0)
      setSize(10)
      setIsLoadingDelete(false)
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100)
    } catch (error) {
      console.log(error);
      setIsLoadingDelete(false)
    }
  };

  const postDefault = async (id) => {
    if (!id) return;
    try {
      const result = await CardsServices.postDefaultSheba(id);
      createToast('موفق', 'شبا پیش‌فرض با موفقیت تغییر یافت.', 'success');
      setPage(0)
      setSize(10)
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100)
    } catch (error) {
      console.log(error);
    }
  };

  // -- OTHER FUNCTIONS --//
  const handleCloseNew = () => {
    setIsNewDialogOpen(false);
    setShebaName('');
    setShebaNumber('');
    setCurrentId(null);
  };

  const formatOwners = (owners) => {
    let ownersStr = '';
    owners.map((v, k) => {
      ownersStr += `${v?.firstName} ${v?.lastName}`;
      if (k != owners.length - 1) {
        ownersStr += '، ';
      }
    });
    return ownersStr;
  };

  const handleOnEdit = (item) => {
    setCurrentId(item?.id);
    setShebaNumber(item?.shebaNumber);
    setShebaName(item?.name);
    setIsNewDialogOpen(true);
  };

  const createMask = (l) => {
    const r = ['I', 'R'];
    for (let i = 0; i < l; i++) {
      r.push(/\d/);
    }
    return r;
  };

  const copyItem = async (v) => {
    try {
      await copy(v);
      createToast('موفق', 'شماره شبا کپی شد.', 'success');
    } catch (e) {
      console.log(e);
    }
  };
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0)
    setSize(10)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
  };
  return (
    <div>
      <SimpleDialog
        title="تعریف شماره شبا جدید"
        open={isNewDialogOpen}
        icon={<Icons icon='Banking' color='#2B3990' size='24' />}
        onClose={handleCloseNew}
        actions={
          <>
            <ButtonLoading
              name={`ثبت و ${currentId ? 'تایید' : 'افزودن شبا'}`}
              loading={isSubmitting}
              variant="contained"
              color="primary"
              onClick={currentId ? putItem : postItem}
              startIcon={<Icons icon='plusCircle' color="#fff" size="18" />}
            />
            <Button variant="contained" onClick={handleCloseNew}>
              انصراف
            </Button>
          </>
        }
      >
        <Typography className={classes.newItemHint}>
          در این صفحه می‌توانید شماره شبا بانکی جدید تعریف کنید.
        </Typography>
        <Grid>
          <InputV2
            masked
            mask={createMask(24)}
            errors={{}}
            rules={['required']}
            dir="ltr"
            name="shebaNumber"
            label="شماره شبا را وارد کنید"
            placeholder="با اعداد انگلیسی"
            forceValue={shebaNumber}
            mainStyle={{ width: '100%', marginLeft: 0, marginRight: 0 }}
            fullWidth
            defaultValue={null}
            onChangeValue={(e) => setShebaNumber(e?.target?.value)}
          />
        </Grid>
        <InputV2
          errors={{}}
          rules={['required']}
          name="shebaName"
          label="عنوان شبا را وارد کنید"
          mainStyle={{ width: '100%', marginLeft: 0, marginRight: 0 }}
          forceValue={shebaName}
          fullWidth
          placeholder="مثلا:‌حساب خرج‌های روزانه"
          defaultValue={null}
          onChangeValue={(e) => setShebaName(e?.target?.value)}
        />
      </SimpleDialog>

      <Grid item xs={12}>
        <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
          <FilterButton
            setOpenFilterDialog={setOpenFilterDialog}
            filters={filters}
          />
          {(String(currentLoaction?.pathname).toUpperCase().includes('IMPREST') ? actionsList['shebaImprestNeWCardPage'] : actionsList['shebaNeWCardPage']) && (
            <Button
              onClick={() => setIsNewDialogOpen(true)}
              color="primary"
              startIcon={<Icons icon='plusCircle' color='#fff' size='18' />}
              variant="contained">
              شماره شبا جدید
            </Button>
          )}

        </Box>
        <Box>
          <FilterPod
            filters={filters}
            onChange={onFiltersChange}
            openFilterDialog={openFilterDialog}
            setOpenFilterDialog={setOpenFilterDialog}
            handleCloseFilterDialog={handleCloseFilterDialog}
          />
        </Box>
      </Grid>

      <TableComponents
        data={getItems}
        columns={columns(postDefault,
          copyItem,
          formatOwners,
          actionsList,
          currentLoaction,
          handleOnEdit,
          setItemIdToDelete,
          setConfirmDeleteModal)}
        isLoading={isLoading}
        ref={tableRef}
        onChange={(ps) => {
          setPage(ps?.pageNumber)
          setSize(ps?.pageSize)
          return getItems(ps)
        }}
      />

      <ConfirmDialog
        loading={isLoadingDelete}
        open={confirmDeleteModal}
        onClose={() => setConfirmDeleteModal(false)}
        onConfirm={deleteItem}
        title="تایید حذف شبا"
        content="آیا از حذف شبا انتخاب شده اطمینان دارید؟"
        confirmButtonText="حذف شبا"
        cancelButtonProps="انصراف"
      />
    </div>
  );
};

export default ShebasList;
